module.exports = __webpack_public_path__ + "static/media/2.af9a66ba.png";